import {random,part, s, p, execute} from './scripting.js';
import {getArgs} from './args.js';
import {preventIntersect, circle} from './structure.js';
import {slice, proportion} from './proportion.js';
import {none} from './none.js';
import {getScriptForTitleSync} from 'decentralized/scripting/scripting.js';
import {getDiameter, getCentroid} from './geometry.js';
import {lazy} from './lazy.js';
import {WIDTH, HEIGHT} from 'components/effects/plane/constants.js';
import {spread} from './spread.js';
import {navierStokes} from './navier-stokes.js';
import {mac} from './mac.js';
import {and, or, neq, gte, lte, eq, cond} from './flow.js';
import {diff} from './diff.js';
import {source} from './source.js';
import {loop} from './loop.js';
import {interpolateSnapshot, nextSnapshot, snapshot} from './snapshot.js';
import {rewind, reset} from './time.js';
import {search, byDevice, not} from './search.js';
import {send, receive} from './msg.js';
import {translate} from './translate.js';
import {bounce} from './bounce.js';
import {vectorField} from './vector-fields.js';
import {altn, alt, every} from './alt.js';
import {getSlicedParameters, sliceParams} from './params.js';


const sin = Math.sin;

export const fluid = () => {
        let slicer = sliceParams();
    return (...args) => {
        console.log("fluid called");
        console.log(args);
        args[0] = getSlicedParameters(slicer, args[0], args.slice(1));
        let {group} = getArgs(args);
        let ret= 
            s(p(
                s(
                    slice(0,1),
                    vectorField(
                        (x,y) => x*y - sin(x),
                        (x,y) => y/x,
                        reset(true),
                    )
                ),
                navierStokes(
                    altn(
                        8,
                        slice(0),
                        none(),
                        slice(1,2),
                        slice(25,26),
                        none()),
                    [group.force(1), group.force(2), group.force(3)],
                        .92,
                    0.6
                ),
            ),
                             every(
                                             8,
                                             cond(
          lte(
              s(
                  slice(0, 1),
                  getDiameter()),
              10),
          s(
              slice(0, 1),
              spread(10))))
             )(...args);
        console.log("ret =", ret);
        return ret;
    };
};

export const navierPreset = (group) =>
s(
    p(
        s(
            slice((coords) => coords,0),
            vectorField(
                (x,y) => x*y - sin(x),
                (x,y) => y/x,
                reset(true),
            )
        ),
    
        navierStokes(
            altn(
                8,
                slice((a) => a, 0),
                none(),
                slice((a) => a, 1),
                slice((a) => a, 25),
                none()),
            [group.force(1), group.force(2), group.force(3)],
            group.knob("diffyx", 0.92, 0.9, 1),
            group.knob("rootxy", 0.6, .01, .8)
        ),
    ),
                                         every(
                                             8,
                                             cond(
          lte(
              s(
                  slice(0, 1),
                  getDiameter()),
              10),
          s(
              slice(0, 1),
              spread(10)))));
